var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 368,
    viewBox: "0 0 559 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M559 336.5C559 353.897 516.691 368 464.5 368C412.309 368 370 353.897 370 336.5C370 319.103 412.309 305 464.5 305C516.691 305 559 319.103 559 336.5Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189 336.5C189 353.897 146.691 368 94.5 368C42.3091 368 0 353.897 0 336.5C0 319.103 42.3091 305 94.5 305C146.691 305 189 319.103 189 336.5Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464 29H534V329H464V29Z",
    fill: "#0017E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M394 29H464V329H394V29Z",
    fill: "#2569E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M394 329L464 300.001L464 329L464 363.001L394 329Z",
    fill: "#2569E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M534 329L464 363.001L464 329L464 300.001L534 329Z",
    fill: "#0017E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94 228.5H164V328.5H94V228.5Z",
    fill: "#47465A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 228.5H94V328.5H24V228.5Z",
    fill: "#C4C4C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 328.5L94 299.5V328.5V362.5L24 328.5Z",
    fill: "#C4C4C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164 328.5L94 362.5V328.5V299.5L164 328.5Z",
    fill: "#47465A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24 228.5L94 199.5V228.5V262.5L24 228.5Z",
    fill: "#C4C4C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M164 228.5L94 262.5V228.5V199.5L164 228.5Z",
    fill: "#C4C4C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M394 29L464 0V29V63L394 29Z",
    fill: "#2569E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M534 29L464 63V29V0L534 29Z",
    fill: "#2569E6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3X);
export default __webpack_public_path__ + "static/media/3x.81ef50b1a5c4436d164c61fdb79eb0a2.svg";
export { ForwardRef as ReactComponent };